import React from "react";
import { useSite } from "../contexts/SiteContext";
import { resolveAssetUrl } from "../lib/api";

const Method = () => {
  const { content } = useSite();
  const method = content.method || { items: [] };
  return (
    <section id="metodo" style={{ background: "#1A1352", padding: "90px 24px", color: "#fff" }}>
      <div style={{ maxWidth: 1240, margin: "0 auto" }}>
        <div className="fade-in" style={{ maxWidth: 780, marginBottom: 56 }}>
          <span className="pill pill-dark" style={{ marginBottom: 16 }}>
            <span style={{ width: 18, height: 1, background: "#fff", opacity: 0.6 }} /> {method.kicker}
          </span>
          <h2 className="h-display" style={{ fontSize: "clamp(34px, 4.6vw, 60px)", color: "#fff", margin: "12px 0 16px" }}>
            {method.titleLine1}<br />
            {method.titleLine2Prefix}<span className="text-grad-purple-light">{method.titleLine2Highlight}</span>{method.titleLine2Suffix}
          </h2>
          <p style={{ color: "rgba(255,255,255,0.7)", fontSize: 16, lineHeight: 1.55, maxWidth: 640 }}>{method.subtitle}</p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 26 }} className="method-grid">
          {(method.items || []).map((p, idx) => (
            <article key={idx} className="fade-in" style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 28, overflow: "hidden", display: "flex", flexDirection: "column" }}>
              <div className="img-zoom-wrap" style={{ aspectRatio: "16/9" }}>
                <img src={resolveAssetUrl(p.image)} alt={p.title} className="img-zoom" />
              </div>
              <div style={{ padding: 26, display: "flex", flexDirection: "column", gap: 10 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <span style={{ color: "rgba(255,255,255,0.5)", fontSize: 11, letterSpacing: "0.1em" }}>{p.n}</span>
                  <span className="pill-orange-solid">Pilar</span>
                </div>
                <h3 className="h-display" style={{ fontSize: 26, color: "#fff", margin: 0 }}>{p.title}</h3>
                <p style={{ color: "rgba(255,255,255,0.7)", fontSize: 14.5, lineHeight: 1.6, margin: 0 }}>{p.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
      <style>{`@media (max-width: 900px){.method-grid{grid-template-columns:1fr !important;}}`}</style>
    </section>
  );
};

export default Method;
